export function assignmentData(widgetData, pageData) {
    if (widgetData) {
        return widgetData;
    } else if (pageData) {
        return pageData;
    }
    return null;
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/global/js/helper/assignmentData.js